<template>
    <div class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-body">
                    <form v-on:submit.prevent="onSubmit" class="rounded">
                        <div class="search-bar-holder px-5 py-3">
                            <button 
                                class="btn btn-icon"
                                :class="{'mt-2' : $breakpoint.xsOnly}"
                                @click="closeStartConversation()">
                                <i 
                                    class="fas fa-lg fa-times" 
                                ></i>
                            </button>
                            <i 
                                class="fas fa-lg fa-search"
                                :class="{'mt-2' : $breakpoint.xsOnly}"
                            ></i>
                            <input class="search-bar no-focus w-100" 
                                v-model="searchInput"
                                @input="searchMatches" 
                                type="search"
                                placeholder="Search for a user or a company name">
                        </div>
                    </form>
                    <div 
                        class="show-results rounded mt-3" 
                        :class="{showList:show}"
                    >
                        <div class="people-list empty" v-if="matchesFound.length < 1">No user found</div>
                        <div class="people-list found" v-else v-for="(person,key) in matchesFound" 
                            @click="selectPerson(person.userId)" :key="key"
                            data-toggle="modal" data-target="#myConversation"
                            >
                            <img class="profile-img" :src="`assets/${person.img}.jpg`" v-if="person.img">  
                            <span class="person-name">{{person.firstName}}&nbsp;{{person.lastName}}</span>
                            &ndash; <span class="company-name">{{person.account.name}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState, mapActions} from 'vuex'
import breakpoint from '@/mixins/index';

export default {
    mixins: [breakpoint],
    data:function(){
        return{
            searchInput:'',
            peopleList:[],
            matchesFound: [],
            show:false
        }
    },
    created: async function(){
        const accountId = this.userLoggedIn.id
        const response = await this.axios.get('/api/getAvailableConversationParticipants', {params: {accountId}})
        
        if (response.data.success){
            this.peopleList = response.data.availableParticipants
        }
    },
    computed: {
        ...mapState('conversation', ['genericConversations']),
        ...mapState('login', ['userLoggedIn'])
    },
    methods:{
        ...mapActions('conversation', ['closeSearchModal', 'selectConversation', 'loadConversation', 'getGenericConversationsList']),
        onSubmit:async function(){
            console.log('on submit')
        },
        closeStartConversation: function(){
            // const el = document.body
            // el.classList.remove('modal-open')
            $(this.$el).modal('hide')
            this.closeSearchModal()
        },
        selectPerson: async function (counterPartUserId){
            const activeUserId = this.userLoggedIn.userId

            /* Check if there is a conversation between them already, if so then select that conversation */
            if (this.genericConversations.length > 0){
                const conversationFoundIndex = this.genericConversations.findIndex((conversation, index) => 
                    conversation.otherParty._id == counterPartUserId)

                if (conversationFoundIndex !== -1){
                    this.selectConversation(conversationFoundIndex)
                    this.loadConversation(this.genericConversations[conversationFoundIndex]._id)
                    this.closeSearchModal()
                    return
                }
            }
            
            /* If there is no exisiting conversation, then start a new one */
            const response = await this.axios.post('/api/startNewConversation', {activeUserId, counterPartUserId})
            
            if (response.data.success){
                const conversationIndexToSelect = this.genericConversations.length
                /* Fetch the updated list of conversations and select the new one */
                this.getGenericConversationsList().then(() => {
                    this.selectConversation(conversationIndexToSelect)
                    this.loadConversation(response.data.createdConversationId)
                })
            }
            
            this.closeSearchModal()
        },
        searchMatches: function (){
            const inputValue = this.searchInput.toLowerCase()
            if(!inputValue){
                this._data.matchesFound = []
                this._data.show=false;
                return
            }

            /* Filter the list of available participants according to matches found for first, last, or company name */
            this.matchesFound = this.peopleList.filter(user => {
                return user.firstName.toLowerCase().indexOf(inputValue) !== -1 ||
                    user.lastName.toLowerCase().indexOf(inputValue) !== -1 ||
                    user.account.name.toLowerCase().indexOf(inputValue) !== -1
            })

            this._data.show = true;
        }
    },
    beforeDestroy() {
        this.closeStartConversation()
    }
}
</script>

<style lang="scss" scoped>
.modal-content {
    background: transparent;

    form {
        background: white;
    }
}
.search-bar{
    display: inline;

    &-holder {
        width: 100%;
        position: relative;

        .fa-search,
        .btn-icon {
            width: 40px; height: 40px; line-height: 40px;
            text-align: center;
            position: absolute;
            left: 0;
            top: 8px;
        }

        .btn-icon {
            right: 0;
            left: auto;
        }
    }
}

.people-list {
    padding: 1rem;

    &.found {
        cursor: pointer;
        border-radius: 1rem;
        
        &:hover {
            background-color: map-get($theme-colors, t_light-grey);
        }

        &:active {
            background-color: map-get($theme-colors, t_grey);
            color: map-get($theme-colors, t_white);
        }
    }
    
    &.empty {
        font-style: italic;
        color: map-get($theme-colors, t_silver);
    }

    .person-name {
        font-weight: 700;
    }

    .company-name {
        font-style: italic;
    }
}

.show-results {
    margin-top:5px;
    border-radius: 5px;
    background-color:transparent;
    transition: all .2s linear;
    // max-height .4s linear , background-color .1s ;
    max-height: 0;
    overflow:hidden;
}

.showList {
    max-height:50vh;
    @include media-breakpoint-down(sm) {
        max-height: calc(100vh - 80px);
        height: calc(100vh - 80px);
    }
    overflow-y: scroll;
    transition:all .4 ease-out;
    background-color:map-get($theme-colors, t_white);
}
@import "@/assets/scss/components/_modals.scss";
</style>
